import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  ClickAwayListener,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useFormContext, useWatch } from "react-hook-form";

import FlightBadge from "../FlightBadge/FlightBadge";
import NextButton from "../NextButton/NextButton";
import PurchaseSummary from "../PurchaseSummary/PurchaseSummary";
import summaryIcon from "../../assets/img/summary.svg";
import {shape} from "../../constants/settings";
import useStyles from "./styles";

const FormFooter = ({
  handleNext,
  handleSubmit,
  activeStep,
  steps,
  onSubmit,
  apiData,
  priceQuoteId,
  tipsValue,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { formState, getValues } = useFormContext();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const itinerarySwitchValue = useWatch({ name: "itinerarySwitch" });
  const contactDetailsSwitchValue = useWatch({ name: "contactDetailsSwitch" });
  const travelCareValue = useWatch({ name: "travelCare" });
  const confirmTermsValue = useWatch({ name: "confirmTerms" });
  const acceptTipsValue = useWatch({ name: "acceptTips" });
  const flightValue = useWatch({
    name: "flight",
  });
  const manualSplitValue =
    useWatch({ name: "manualSplit" }) || getValues("manualSplit");

  const selectedFlight =
    apiData?.priceQuotes?.find((item) => item?.id == flightValue) ||
    apiData?.priceQuotes.find((item) => item?.id == priceQuoteId);

  if(!selectedFlight?.parts?.multiple){
    delete selectedFlight?.parts?.multiple
  }

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };
  const handleDisableButton = () => {
    if (activeStep === 0) {
      return !itinerarySwitchValue;
    }
    if (activeStep === 1) {
      const formErrors = (({ cards, ...rest }) => rest)(formState?.errors);
      return !contactDetailsSwitchValue || Object.keys(formErrors).length > 0;
    }
    if (activeStep === 2) {
      const errors = formState?.errors?.travelCare || {};
      return !travelCareValue || !!errors?.message;
    }
    if (activeStep === 3) {
      return !confirmTermsValue || Object.keys(formState.errors).length > 0;
    }
    return false;
  };

  let CurrentLeftShape = mobile ? shape.leftMobile : shape.left
  let CurrentRightShape = mobile ? shape.rightMobile : shape.right

  return (
    <Box className={classes.footerContainer}>
      <Grid container className={classes.formFooter}>
        <Box
          className={classes.leftShape}
          display="flex"
          justifyContent="flex-start"
        >
          <img src={CurrentLeftShape} alt="img" />
        </Box>
        <Box
          className={classes.rightShape}
          display="flex"
          justifyContent="flex-end"
        >
          <img src={CurrentRightShape} alt="img" />
        </Box>
        <Grid item xs={5} sm={3} className={classes.summary}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <Box display="flex" alignItems="center">
              <Box
                onClick={handleClick}
                display="flex"
                alignItems="center"
                className={classes.pointer}
              >
                <Box
                  className={classes.summaryTrigger}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mr={1}
                >
                  <img src={summaryIcon} alt="summary" />
                </Box>

                <Box>
                  <Typography variant="body1" color="secondary">
                    Purchase Summary
                  </Typography>
                </Box>
              </Box>
              {open ? (
                <PurchaseSummary
                  selectedFlight={selectedFlight}
                  travelCareValue={travelCareValue}
                  tipsValue={tipsValue}
                  acceptTipsValue={acceptTipsValue}
                  manualSplitValue={manualSplitValue}
                />
              ) : null}
            </Box>
          </ClickAwayListener>
        </Grid>
        <Grid item xs={6} className={classes.flightDetails}>
          <Box
            display="flex"
            justifyContent={activeStep < 4 ? "center" : "flex-end"}
            alignItems="center"
          >
            <Box
              mr={1}
              className={classes.counter}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="body1" color="primary">
                {apiData?.priceQuotes?.findIndex(
                  (item) => item?.id == flightValue
                ) + 1 ||
                  apiData?.priceQuotes?.findIndex(
                    (item) => item?.id == priceQuoteId
                  ) + 1}
              </Typography>
            </Box>
            <Typography variant="body1" color="secondary">
              {apiData?.airlines[selectedFlight?.validatingCarrier]?.name ||
                selectedFlight?.validatingCarrier}
            </Typography>
          </Box>
        </Grid>
        {activeStep < 4 && (
          <Grid item xs={3}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <NextButton
                selectedFlight={selectedFlight}
                handleNext={
                  activeStep === steps.length - 1
                    ? handleSubmit(onSubmit)
                    : handleNext
                }
                disabled={handleDisableButton()}
                location="footer"
                travelCareValue={travelCareValue}
                tipsValue={tipsValue}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default FormFooter;
